import React from 'react';
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom';

// Layout
import AppLayout from './layout/AppLayout';

function Masuk(){
  return <div>Masuk</div>
}

function Daftar(){
  return <div>Daftar</div>
}

const App = () => {
  return (
    <Router>
      <AppLayout>
        <Switch>
          <Route path="/masuk">
            <Masuk />
          </Route>
          <Route path="/daftar">
            <Daftar />
          </Route>
        </Switch>
      </AppLayout>
    </Router>
  );
}

export default App;
